import React from 'react';
import '../styles/Leadership.css';

const Leadership = () => {

    
  return (
    <div className='Leadership_main_container'>
        
        <div className='Leadership_card_container'>
            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Abiola Yushau</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>CHIEF SOFTWARE ARCHITECT</p>
            </div>

            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Ikechukwu Ugoanyanwu</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>HEAD OF FINANCE</p>
            </div>

            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Mosunmola Adewale-Akobada</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>SERVICE DELIVERY/SUPPORT MANAGER</p>
            </div>

            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Adeola Yomi-Patrick</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>PRODUCT MANAGER</p>
            </div>

            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Chinyelu Chikwendu</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>HEAD, STRATEGY</p>
            </div>

            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Nwakaego Ojekale</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>HEAD, HUMAN CAPITAL MANAGEMENT</p>
            </div>

            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Kehinde Adeniyi</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>CEO OF VATEBRAPAY</p>
            </div>

            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Ben Iyoha</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>HEAD, CORPORATE SERVICES</p>
            </div>

            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Aderonke Okewoye</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>BUSINESS MANAGER, ENTERPRISE SOLUTIONS</p>
            </div>

            <div className='Leadership_card'>
                <p className='Leadership_card_text1'>Oluwole Aduloju</p>
                <div className='leadership_card_hr'></div>
                <p className='Leadership_card_text2'>HEAD EXAMINATION BODIES</p>
            </div>


        </div>

        
    </div>
  )
}

export default Leadership